export default __webpack_public_path__ + "static/media/plugged_by_company_card.bf88d97c.svg";